<h2 mat-dialog-title *ngIf="title">
    {{title}}
  </h2>
  
  <div mat-dialog-content *ngIf="message">
    <p>{{message}}</p>
  </div>
  
  <div mat-dialog-actions [ngClass]="{'justify-content-end' : actionsToRight, 'justify-content-start' : !actionsToRight}">
    <button [ngClass]="{'order-1 ml-2': confirmToRight, 'order-0': !confirmToRight}" mat-button color="primary" (click)="onConfirm()">Yes</button>
    <button mat-button color="warn" (click)="onDismiss()">No</button>    
  </div>
  